<!-- eslint-disable max-lines -->
<template>
    <paper id="agingProduct">
        <m-pane
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :searchTotalTitle="searchTotalTitle"
            :initSearchInfo="initSearchInfo"
            @saveData="saveData"
            @row-db-click="rowDBclick"
            @check-btn="checkBtn"
            @edit-btn="editBtn"
            @switch-change="switchChange"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            searchId="test"
            pageID="test"
            class="inventory-flow"
        >
            <div slot="table-module-btn">
                <reportExport #default="{ submit }" reportCode="REPORT_OTP_INV_FLOW">
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <span v-has="'03010001'">
                        <el-button icon="icon-daochu" size="mini" @click="exportFile(submit)"></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
            </div>
        </m-pane>
    </paper>
</template>
<script>
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

import dayjs from 'dayjs';
import mPane from '@/components/otpPanel';
import config from './config.json';
import paper from '@/components/core/paper/Paper';
import reportExport from '@/components/lots/reportExportPlugin';
import { getinventoryFlow, getTotalCounts } from '../../../api/stockManage';
import { dateTimes } from '../../../judge/configCenter';
import { mapState } from 'vuex';
export default {
    name: 'inventoryFlow',
    components: { mPane, paper, reportExport },
    data() {
        return {
            config: config,
            totalData: [],
            loading: false,
            pageTotal: 0,
            searchTotalTitle: config.searchTotalTitle,
            searchParams: {
                pageSize: 10,
                pageNo: 1
            },
            initSearchInfo: {},
            exportParams: {},
            isFirstSearch: true
        };
    },
    methods: {
        _validateSearchParams() {
            const startTime = this.searchParams.createStartTime || 0;
            const endTime = this.searchParams.createEndTime || 0;
            const timeDifference = new Date(endTime).getTime() - new Date(startTime).getTime();
            if (!this.searchParams.custOrderNo && !startTime) {
                return '客户订单号 和 创建时间 不可同时为空';
            } else if (!this.searchParams.orderNo && startTime) {
                if (timeDifference > 32 * 24 * 60 * 60 * 1000) {
                    return '按时间查询时，查询/导出 时间跨度不可超过一个月！';
                }
            }
        },
        async getList(searchCountFlag) {
            if (this._validateSearchParams()) return this.$message.warning(this._validateSearchParams());
            this.isFirstSearch = false;
            const res = await getinventoryFlow(this.searchParams);
            if (res) {
                if (res.data.totalPage !== 0 && this.searchParams.pageNo > res.data.totalPage) {
                    this.searchParams.pageNo = res.data.totalPage;
                    this.getList();
                } else {
                    this.totalData = res.data.list || [];
                    if (!searchCountFlag) { this.getPageTotal(); }
                }
            } else {
                this.totalData = [];
            }
        },
        async getPageTotal() {
            const totalCountRes = await getTotalCounts(this.searchParams);
            this.pageTotal = totalCountRes ? totalCountRes.data : 10000;
        },
        rowDBclick(row) {
            // 表格内双击事件
        },
        checkBtn(data) {
            // 表格内按钮查看事件;
            this.visible = true;
        },
        editBtn(data) {
            // 表格内按钮修改事件;
        },
        selectChange(data) {
            // 表格内选择变化
            this.selectRow = data;
        },
        switchChange(data) {
            // 表格内switch切换事件
        },
        searchChange(data) {
            // 提交搜索框
            if (data.time) {
                data.createStartTime = dateTimes(data.time[0]) || '';
                data.createEndTime = dateTimes(data.time[1]) || '';
            }
            delete data.time;

            delete data.itemName;
            this.searchParams = { ...data, pageNo: 1, pageSize: this.searchParams.pageSize };
            this.exportParams = { ...this.searchParams };
            this.getList();
        },
        pageChange(data) {
            // 分页器页数变化
            this.searchParams.pageNo = data;
            this.getList(true);
        },
        sizeChange(data) {
            // 分页器页数大小变化
            this.searchParams.pageSize = data;
            this.getList(true);
        },
        addData() {
            // 表格新增方法
            this.$refs.tablePage.$refs.table.addRow();
        },
        saveData(data) {
            // 表格新增修改后返回数据
        },
        redomet(data) {
            // 这是删除方法
        },
        refresh() {
            // 表格内刷新按钮
        },
        init() {
            const initSearchInfo = {};
            const startTime = dayjs().subtract(6, 'days').startOf('day');
            const endTime = dayjs().endOf('day');
            initSearchInfo.time = [startTime.toDate(), endTime.toDate()];
            this.initSearchInfo = initSearchInfo;
            this.$router.replace({ name: 'inventoryFlow', query: {} });
            // this.getInitList();
        },
        getInitList() {
            setTimeout(() => {
                this.$refs.tablePage.$refs.searchList.onSearchChange();
            }, 50);
        },
        // 导出
        exportFile(submit) {
            const isFirstSearch = this.isFirstSearch;
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            if (this._validateSearchParams()) return isFirstSearch ? false : this.$message.warning(this._validateSearchParams());
            submit({ ...this.exportParams, tenantCode: this.currentTenant.tenantCode });
            this.isFirstSearch = false;
        }
    },
    mounted() {
        // this.getList();
        this.init();
    },
    computed: {
        ...mapState({
            currentTenant: state => state.currentTenant
        })
    }
};
</script>
<style lang="less">
</style>